module.exports = __webpack_public_path__ + "img/grfwbg.861e9448.png";